
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("habRv", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $d7o2V = parcelRequire("d7o2V");


var $lspPP = parcelRequire("lspPP");







function $1befae30f885f9b9$export$f9718e664221d42a({ render: render }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContextConsumer), null, (actions)=>render(actions));
}



var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $6UYek = parcelRequire("6UYek");





var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");

function $0779e224f4e996ea$export$6f846e47e87c2a09() {
    const { handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $42omo.useCallback)(()=>{
        handleClose();
    }, [
        handleClose
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return null;
}



var $jmjWc = parcelRequire("jmjWc");

/**
 * @generated SignedSource<<0baf6598ce2105bbd0dfb00331acd643>>
 * @relayHash 93869ef63ea6728086df26bf7fee35ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 909190e21c94c8720c09c105a3399859af3a1dd2592d10fe07fd62c602bf5aae
const $0c76ab748035afc7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v10 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v14 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v7 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "93869ef63ea6728086df26bf7fee35ac",
            "id": "909190e21c94c8720c09c105a3399859af3a1dd2592d10fe07fd62c602bf5aae",
            "metadata": {},
            "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
            "operationKind": "query",
            "text": "query InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}},ancestors{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},parentId}}}"
        }
    };
}();
$0c76ab748035afc7$var$node.hash = "101bf587c7e4148c07a0c0957b8ef4ca";
var $0c76ab748035afc7$export$2e2bcd8739ae039 = $0c76ab748035afc7$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $4u5NT = parcelRequire("4u5NT");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");





var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");





var $7W8i8 = parcelRequire("7W8i8");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8WQTF = parcelRequire("8WQTF");


var $kgNLQ = parcelRequire("kgNLQ");


var $lb2Lp = parcelRequire("lb2Lp");


var $aSsfA = parcelRequire("aSsfA");


var $1ZGYV = parcelRequire("1ZGYV");


var $eTcMK = parcelRequire("eTcMK");


var $jMyy4 = parcelRequire("jMyy4");


var $ifBRq = parcelRequire("ifBRq");

const $61084f20d36cc3f6$var$InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery = (0, $0c76ab748035afc7$export$2e2bcd8739ae039);
const $61084f20d36cc3f6$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $61084f20d36cc3f6$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
const $61084f20d36cc3f6$export$3cf51438c4a7a1a = ({ isArchived: isArchived, rendererRef: rendererRef, flags: flags })=>{
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const commentId = focusedCommentId || replyToCommentId || editCommentId;
    // NEW FLOW: Use useCommentById hooks when experiment is enabled
    const skipNewFlow = !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow || !foundComment?.parentId
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($61084f20d36cc3f6$var$InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "@confluence/comments-query-param-handlers"
    });
    if (error) {
        $61084f20d36cc3f6$var$logger.error`An error occurred when querying the focused comment status; ${error}`;
        // TODO: If this query fails, there isn't much we can do, so just track it with experience tracker?
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const queryParamData = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // NEW FLOW: Extract data from useCommentById hooks
            if (!commentError && !commentLoading && foundComment) {
                const location = foundComment.location;
                const parentId = foundComment.parentId;
                const parentLocation = parentId && !parentError && !parentLoading && parentComment ? parentComment.location : undefined;
                // Return the data if this is a root commment (it doesn't have a parent comment) and we
                // have just that comment's data or if it's a reply and we also have a parent comment
                // with valid data.  This prevents returning incomplete data while parent comment is
                // loading, which causes the dependent memoized items to be generated multiple times and in
                // turn causes multiple simulated annotation clicks when we only want one simulated click
                // after everything is loaded.
                if (!parentId || parentComment) return {
                    location: location,
                    parentId: parentId,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        } else {
            // OLD FLOW: Extract data from GraphQL query
            if (!error && !loading && data) {
                const location = data.comments?.nodes?.[0]?.location;
                const parentId = data.comments?.nodes?.[0]?.parentId;
                const parentLocation = data.comments?.nodes?.[0]?.ancestors?.[0]?.location;
                return {
                    location: location,
                    parentId: parentId,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        }
    // Note that we only want to regenerate this data only when the data contents has changed, not
    // when just the reference to the data has changed. Otherwise, we will generate the data twice:
    // once when useCommentById()'s single comment query returns with data and a second time when
    // the useAllCommentsData()'s query completes with similar data but a different reference -
    // which causes the dependent memoized items to be generated multiple times which in turn
    // causes multiple simulated annotation clicks when we only want one simulated click.
    // Note that looking at the comment IDs is sufficient because we only want to open/scroll to
    // the comment once even if other pieces of the comment's data change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentId,
        data,
        loading,
        error,
        foundComment?.id,
        commentLoading,
        commentError,
        parentComment?.id,
        parentLoading,
        parentError
    ]);
    const queryParamDataExt = (0, $42omo.useMemo)(()=>{
        const { location: location, parentLocation: parentLocation } = queryParamData || {};
        return location?.inlineMarkerRef ? {
            annotationId: location.inlineMarkerRef,
            isResolved: Boolean(location.inlineResolveProperties?.resolved)
        } : {
            annotationId: parentLocation?.inlineMarkerRef,
            isResolved: Boolean(parentLocation?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    // Create callback for handling replyToCommentId when comment is rendered
    const onReplyToCommentReady = (0, $42omo.useCallback)(()=>{
        if (!replyToCommentId) return;
        // Get comment data from either new flow or old flow
        const rawComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : data?.comments?.nodes?.[0];
        if (rawComment) {
            const commentWithAuthor = rawComment;
            // Get annotationId from the reply-to comment's location
            const annotationId = queryParamDataExt?.annotationId;
            // Set the thread key to the annotationId of the parent comment we're replying to
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
            // Access author field - both types have this field
            const author = commentWithAuthor?.author;
            // Set up reply state
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        replyToCommentId,
        foundComment,
        data,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $42omo.useCallback)(()=>{
        return $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $42omo.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location } = queryParamData;
        const { annotationId: annotationId } = queryParamDataExt;
        if (location) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                }
            } else if (annotationId && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                // Comment exists in DB (location is truthy) but annotation mark may be gone from page content.
                // Check if annotation mark exists in renderer; if not, open DELETED_CONTENT panel.
                const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs.id === annotationId);
                if (!annotationExists) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                    hasHandledCommentLink.current = true;
                    return;
                }
            }
        } else {
            // Wait for the comment query to finish before checking if annotation exists
            // This prevents race condition where we check before comment data is available
            // Only apply this check when the feature flag is enabled
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                // Wait for renderer actions and comment query to finish (isCommentNotFound is undefined while query is loading)
                if (!rendererActions || annotationId && isCommentNotFound === undefined) return;
            }
            // Check if annotation exists in renderer only when we need to make the decision
            // Ensure rendererActions is available before accessing it
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs.id === annotationId);
            if (annotationId && !annotationExists && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE); // needed so that the view knows which thread to scroll to after rendering the threads
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList
    ]);
    // Only display the "comment not found" flag once
    (0, $42omo.useEffect)(()=>{
        if (isCommentNotFound) {
            const VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `viewpage-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        }
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
const $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // If the already open container is showing the correct comment, don't send another click event to open it
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        // Deep-link scrolling: unified navigation when we have a comment id; otherwise scroll to the mark
        // (replies skip mark-only scroll here — reply scrolling runs after the reply renders to avoid double scroll)
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $61084f20d36cc3f6$var$withInlineCommentQueryParamUnification = (Component)=>(props)=>{
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ifBRq.CommentQueryParamsListener), {
            isArchived: props.isArchived,
            rendererRef: props.rendererRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
    };
const $61084f20d36cc3f6$export$34418bee20f397f = (0, $7aRa9.withFlags)($61084f20d36cc3f6$var$withInlineCommentQueryParamUnification($61084f20d36cc3f6$export$3cf51438c4a7a1a));






var $a8ZQ3 = parcelRequire("a8ZQ3");







const $f7fdc9c663d47c5a$export$2f2529470fc43ad6 = /*#__PURE__*/ (0, $42omo.memo)(({ actions: actions, pageId: pageId })=>{
    const { setRendererActions: setRendererActions } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $42omo.useEffect)(()=>{
        setRendererActions(actions, pageId);
    }, [
        actions,
        pageId,
        setRendererActions
    ]);
    return null;
});






var $804Ue = parcelRequire("804Ue");
/* eslint-disable import/no-duplicates */ 



var $cUycv = parcelRequire("cUycv");


var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");





var $aMfLn = parcelRequire("aMfLn");














var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");


var $cD1qu = parcelRequire("cD1qu");


var $3BPrE = parcelRequire("3BPrE");


var $03oqz = parcelRequire("03oqz");


var $b11gn = parcelRequire("b11gn");

const $039e5ede5bcb8619$var$sendFailedPubsubEvent = ({ createAnalyticsEvent: createAnalyticsEvent, publishVersionNumber: publishVersionNumber, publishedDocumentVersion: publishedDocumentVersion })=>{
    if (createAnalyticsEvent && publishVersionNumber && publishedDocumentVersion) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'failed',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments',
            attributes: {
                stepVersion: publishVersionNumber,
                documentVersion: publishedDocumentVersion
            }
        }
    }).fire();
};
const $039e5ede5bcb8619$var$isEventCommentThreadOpen = (markerRef)=>{
    if (!markerRef) return false;
    const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
    // Figure out if the reply's parent markerRef is open
    // HACK: Is there a way to do this without query selectors?
    return focusedMarkerRef && focusedMarkerRef.id === markerRef;
};
const $039e5ede5bcb8619$export$4197a8a52311d1d2 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'received',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments'
        }
    }).fire();
    const { markerRef: markerRef, step: step, publishVersionNumber: publishVersionNumber } = inlineCommentRequestBody;
    // If the users content is out of date or different, the steps from this pubsub event will be wrong
    // The new comment flag shown by VQR will be triggered to refetch the content
    if (step && publishVersionNumber === publishedDocumentVersion && !needsContentUpdate) {
        const { to: to, from: from, pos: pos, mark: { attrs: { annotationType: annotationType } } } = step;
        const position = pos !== undefined && pos !== null ? {
            to: pos,
            from: pos
        } : {
            to: to,
            from: from
        };
        const annotation = {
            annotationId: markerRef,
            annotationType: annotationType
        };
        const result = rendererActions?.applyAnnotation(position, annotation);
        if (result) updateDocument && updateDocument(result.doc);
    } else {
        if (!needsContentUpdate) setContentNeedsUpdate && setContentNeedsUpdate(true);
        // If we can't apply the step, send an event
        $039e5ede5bcb8619$var$sendFailedPubsubEvent({
            createAnalyticsEvent: createAnalyticsEvent,
            publishVersionNumber: publishVersionNumber,
            publishedDocumentVersion: publishedDocumentVersion
        });
    }
};
const $039e5ede5bcb8619$export$14eb0441cdcaaa35 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, eventEmitter: eventEmitter })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
    const deleteResult = rendererActions?.deleteAnnotation(markerRef, (0, $cUycv.AnnotationTypes).INLINE_COMMENT);
    if (deleteResult) updateDocument && updateDocument(deleteResult.doc);
};
const $039e5ede5bcb8619$var$refreshCommentThreadIfOpen = ({ contentId: contentId, inlineCommentRequestBody: inlineCommentRequestBody })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef) && contentId) // If so, update it's cache entry
    (0, $03oqz.refreshCommentThread)(contentId, markerRef);
// Otherwise do nothing
};
let $039e5ede5bcb8619$var$pagePublicationEventParams = {};
const $039e5ede5bcb8619$var$setPagePublicationEventParams = (params)=>{
    $039e5ede5bcb8619$var$pagePublicationEventParams = params;
};
const $039e5ede5bcb8619$var$onPagePublicationEvent = async (event, payload)=>{
    let confVersion;
    let trigger;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        confVersion = payload.pageUpdated.confVersion;
        trigger = payload.pageUpdated.trigger;
    } else {
        confVersion = payload.pageUpdatedRequestBody.confVersion;
        trigger = payload.pageUpdatedRequestBody.trigger;
    }
    const { setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, setPublishedDocumentVersion: setPublishedDocumentVersion } = $039e5ede5bcb8619$var$pagePublicationEventParams;
    // need to modify this for subscriptions since the event wont have avi/know content type this way
    // myabe the type in the page updated response will be what we want
    // if pageupdated trigger is publish
    if ((event === (0, $3BPrE.PagePubSubEvents).PagePublished || event === (0, $3BPrE.PagePubSubEvents).BlogPublished || event === (0, $3BPrE.PageSubscriptionEvents).PageUpdated && trigger === 'publish') && publishedDocumentVersion !== confVersion) {
        // TODO: Eventually we want to read the values passed to us to see if this is positional breaking
        setContentNeedsUpdate && setContentNeedsUpdate(true);
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setPublishedDocumentVersion && setPublishedDocumentVersion(confVersion);
    }
};
let $039e5ede5bcb8619$var$commentPublicationEventParams = {};
const $039e5ede5bcb8619$export$11d6bf62aa2fcbf9 = (params)=>{
    $039e5ede5bcb8619$var$commentPublicationEventParams = params;
};
const $039e5ede5bcb8619$export$8579923c4bc2600 = async (event, payload)=>{
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const { accountId: accountId } = payload;
    let inlineCommentRequestBody;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event];
    else inlineCommentRequestBody = payload.inlineCommentRequestBody;
    const { inlineCommentType: inlineCommentType, markerRef: markerRef, commentId: commentId } = inlineCommentRequestBody || {};
    const { contentId: contentId, currentUserId: currentUserId, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = $039e5ede5bcb8619$var$commentPublicationEventParams;
    // Don't do anything when the current user performs an action
    if (accountId === currentUserId) return;
    const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).RendererInlineCommentsPubSub);
    startCommentsPubSubExperience(event);
    try {
        const lastestStoredCommentData = storedCommentData?.();
        const isReply = inlineCommentType === 'REPLY';
        // These promises were previously dispatched as fire-and-forget (`void`).
        // Arguably they should be awaited, but until they are, we keep track of
        // their failures by collecting them here and awaiting `Promise.all` at
        // the end so any rejection becomes a `fail` on the experience and a
        // successful resolution becomes a `succeed`.
        const trackedPromises = [];
        switch(event){
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
                if (event) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId && contentId) {
                            // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                            await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            // Synchronously process the updated comment data cache to get it added to the open
                            // comments array. If we don't manually do this now, the updated cache isn't processed
                            // until the next render cycle when useAllCommentsDataQuery updates, which is too late
                            // for the updateRendererAnnotations() call below. If the comment is not in the open
                            // array at that time, the annotation is not added to the orderedActiveAnnotationIdList
                            // and the reopened comment then appears to be attached to deleted content.
                            const updatedCachedData = (0, $NYiei.getCommentsDataFromCache)(contentId);
                            (0, $4L9ve.getProcessedCommentsDataActions)().processCommentsData({
                                data: updatedCachedData,
                                pageMode: (0, $cD1qu.PageMode).VIEW
                            });
                        }
                    } else // We load resolved + active separately, so unless the user has visited the resolved tab, the comment thread won't be in the state
                    // Hance the await here - as part of this function we update state
                    await (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (markerRef && reopenParentComment) reopenParentComment({
                        threadKey: markerRef,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: commentId
                    });
                }
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $cUycv.AnnotationMarkStates).ACTIVE
                    }
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
                // If the thread is open, close it and clear highlight
                if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) {
                    eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                    if ((0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight?.(null);
                }
                // Remove the resolved comment from the navigation list
                if (setOrderedActiveAnnotationIdList && orderedActiveAnnotationIdList && (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== markerRef));
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [markerRef]: {
                        id: markerRef,
                        annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $cUycv.AnnotationMarkStates).RESOLVED
                    }
                });
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    trackedPromises.push((0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }));
                }
                const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                updateRemovedCommentIdsMap && inlineResolveProperties && inlineText && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                    isReply: isReply,
                    commentType: (0, $8i27m.CommentType).INLINE,
                    resolvedProperties: {
                        inlineResolveProperties: inlineResolveProperties,
                        inlineText: inlineText
                    }
                });
                const { replies: replies = [] } = inlineCommentRequestBody;
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId,
                    ...replies
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated:
                if (inlineCommentType === 'TOP_LEVEL') {
                    // New comments data manger needs to call this AFTER update. See note below
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) $039e5ede5bcb8619$export$4197a8a52311d1d2({
                        inlineCommentRequestBody: inlineCommentRequestBody,
                        rendererActions: rendererActions,
                        updateDocument: updateDocument,
                        needsContentUpdate: needsContentUpdate,
                        setContentNeedsUpdate: setContentNeedsUpdate,
                        publishedDocumentVersion: publishedDocumentVersion,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment,
                                onError: failCommentsPubSubExperience
                            });
                            // This needs to happen AFTER the cache update. applyStepAndAddCommentToDoc triggers the doc to re-render, which triggers getRendererAnnotationStates
                            // getRendererAnnotationStates pulls data from the cache to determine which annotations to show
                            // In the legacy version this wasn't a problem, since it does a full network call
                            $039e5ede5bcb8619$export$4197a8a52311d1d2({
                                inlineCommentRequestBody: inlineCommentRequestBody,
                                rendererActions: rendererActions,
                                updateDocument: updateDocument,
                                needsContentUpdate: needsContentUpdate,
                                setContentNeedsUpdate: setContentNeedsUpdate,
                                publishedDocumentVersion: publishedDocumentVersion,
                                createAnalyticsEvent: createAnalyticsEvent
                            });
                        }
                    } else trackedPromises.push((0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        addNewCommentThreads: addNewCommentThreads
                    }));
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else if (isReply) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment,
                                onError: failCommentsPubSubExperience
                            });
                        }
                    } else trackedPromises.push((0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: lastestStoredCommentData,
                        setStoredCommentData: setStoredCommentData
                    }));
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                }
                break;
            // just for replies
            case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
            case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
                if (isReply) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment,
                                onError: failCommentsPubSubExperience
                            });
                        }
                    } else trackedPromises.push((0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: lastestStoredCommentData,
                        setStoredCommentData: setStoredCommentData
                    }));
                    // Check if the annotation exists in the renderer DOM before updating unread comments
                    const annotationElement = document.getElementById(markerRef);
                    if (annotationElement && updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                }
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
                // Always handle annotation logic
                if (inlineCommentType === 'TOP_LEVEL') $039e5ede5bcb8619$export$14eb0441cdcaaa35({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    eventEmitter: eventEmitter
                });
                else if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) $039e5ede5bcb8619$var$refreshCommentThreadIfOpen({
                    contentId: contentId,
                    inlineCommentRequestBody: inlineCommentRequestBody
                });
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (deleteCommentInCache && commentId) deleteCommentInCache({
                        commentId: commentId,
                        onError: failCommentsPubSubExperience
                    });
                }
                // both a parent comment and reply can be deleted
                updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    isReply: isReply,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'remove');
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached:
                $039e5ede5bcb8619$export$4197a8a52311d1d2({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    needsContentUpdate: needsContentUpdate,
                    setContentNeedsUpdate: setContentNeedsUpdate,
                    publishedDocumentVersion: publishedDocumentVersion,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                break;
            case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
            case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
                // If the initial comment thread is open, refresh it
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    trackedPromises.push((0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }));
                } else if (updateCommentBody) trackedPromises.push((0, $03oqz.handleEditedComment)({
                    contentId: contentId,
                    markerRef: markerRef,
                    commentId: commentId,
                    updateCommentBody: updateCommentBody
                }));
                break;
            default:
                failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                break;
        }
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedPromises.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        } else {
            // Always update if we've handled the event
            if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted) {
                if (rendererActions && contentId && updateUnresolvedInlineComment) trackedPromises.push((0, $aMfLn.updateRendererAnnotations)({
                    rendererActions: rendererActions,
                    contentId: contentId,
                    updateUnresolvedInlineComment: updateUnresolvedInlineComment
                }));
            }
        }
        if ((0, $9wGTI.fg)('cc_comments_pubsub_experience_tracking_enabled')) {
            await Promise.all(trackedPromises);
            succeedCommentsPubSubExperience();
        }
    } catch (error) {
        failCommentsPubSubExperience(error);
        throw error;
    }
};
function $039e5ede5bcb8619$export$9ac99a17b366f8ef({ contentId: contentId, currentUserId: currentUserId, contentType: contentType, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, setContentNeedsUpdate: setContentNeedsUpdate, needsContentUpdate: needsContentUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addSubscriber: addSubscriber, setContentId: setContentId, setContentType: setContentType, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }) {
    const pubSubResourceType = contentType || 'page';
    $039e5ede5bcb8619$export$11d6bf62aa2fcbf9({
        contentId: contentId,
        currentUserId: currentUserId,
        rendererActions: rendererActions,
        updateDocument: updateDocument,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        needsContentUpdate: needsContentUpdate,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        createAnalyticsEvent: createAnalyticsEvent,
        addReplyToCommentThread: addReplyToCommentThread,
        addNewCommentThreads: addNewCommentThreads,
        updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
        reopenParentComment: reopenParentComment,
        updateCommentBody: updateCommentBody,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        updateUnreadCommentIDSet: updateUnreadCommentIDSet,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        setActiveHighlight: setActiveHighlight,
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
    });
    $039e5ede5bcb8619$var$setPagePublicationEventParams({
        currentUserId: currentUserId,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        setPublishedDocumentVersion: setPublishedDocumentVersion
    });
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentId || !setContentType) return;
        const subscriptions = [];
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentResolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentResolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUnresolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUnresolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubRendererInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'rendererInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubEditorInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'editorInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentDeleted',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentDeleted'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentReattached',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentReattached'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUpdated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUpdated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubPageUpdated',
                onSubscriptionData: $039e5ede5bcb8619$var$onPagePublicationEvent,
                delta: 'pageUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriptions.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriptions;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        }).catch((error)=>{
            throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
        });
    });
}
function $039e5ede5bcb8619$export$d3539dc2c41bd511({ contentId: contentId, contentType: contentType, subscriptions: subscriptions, removeSubscriber: removeSubscriber }) {
    const pubSubResourceType = contentType || 'page';
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber of subscriptions)removeSubscriber?.(subscriber);
    else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
    });
}



var $fgQGl = parcelRequire("fgQGl");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $fHAwL = parcelRequire("fHAwL");


var $bQm3c = parcelRequire("bQm3c");


var $7boqA = parcelRequire("7boqA");


var $a3q17 = parcelRequire("a3q17");





var $WheoQ = parcelRequire("WheoQ");





var $3D6uL = parcelRequire("3D6uL");


var $fFRTr = parcelRequire("fFRTr");


const $24269a0cd7d91594$var$SelectionComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GK726",
    name: "SelectionComponentLoader",
    loader: async ()=>(await (parcelRequire("5XUQk"))).SelectionComponent
});

const $24269a0cd7d91594$var$HoverComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8tl48",
    name: "HoverComponentLoader",
    loader: async ()=>(await (parcelRequire("aWPJG"))).HoverComponent
});

const $24269a0cd7d91594$var$ViewComponentLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAh0o",
    name: "ViewComponentLoader",
    loader: async ()=>(await (parcelRequire("9rqD4"))).ViewComponent
});

const $24269a0cd7d91594$var$InlineCommentLinkHandlerLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0Ufwq",
    name: "InlineCommentLinkHandlerLoader",
    loader: async ()=>(await (parcelRequire("43Gw3"))).InlineCommentLinkHandler
});
const $24269a0cd7d91594$var$InlineCommentsPubSubHandler = ({ contentId: contentId, contentType: contentType, updateDocument: updateDocument, rendererActions: rendererActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setDocumentUpdated: setDocumentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $42omo.useRef)([]);
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody } = (0, $8i27m.useCommentsDataActions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)() || {};
    const latestStoredCommentRef = (0, $42omo.useRef)(storedCommentData);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    (0, $42omo.useEffect)(()=>{
        latestStoredCommentRef.current = storedCommentData;
    }, [
        storedCommentData
    ]);
    const unsubscribeFromPubSub = (0, $42omo.useCallback)(()=>{
        if (subscriptions.current.length === 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        (0, $039e5ede5bcb8619$export$d3539dc2c41bd511)({
            contentId: contentId,
            contentType: contentType,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current
        });
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) subscriptions.current = [];
    }, [
        contentId,
        contentType,
        removeSubscriber
    ]);
    const subscribeToPubSub = (0, $42omo.useCallback)(()=>{
        if (subscriptions.current.length > 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // When new data manager is enabled, multiple active subscriptions will cause multiple cache-writes, which we don't want.
        // Instead of returning early here, we unsub + resub so that values in setUpRendererInlineCommentsPubSub stay up to date.
        unsubscribeFromPubSub();
        subscriptions.current = (0, $039e5ede5bcb8619$export$9ac99a17b366f8ef)({
            contentId: contentId,
            currentUserId: userId,
            contentType: contentType,
            rendererActions: rendererActions,
            updateDocument: updateDocument,
            updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
            setContentNeedsUpdate: setDocumentNeedsUpdate,
            needsContentUpdate: Boolean(documentNeedsUpdate),
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            createAnalyticsEvent: createAnalyticsEvent,
            addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addNewCommentThreads,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            updateCommentBody: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : updateCommentBody,
            storedCommentData: ()=>latestStoredCommentRef.current,
            setStoredCommentData: setStoredCommentData,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            setActiveHighlight: setActiveHighlight,
            setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
        }) || [];
        return subscriptions.current;
    // We only need to respond to values that CAN change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        userId,
        contentType,
        rendererActions,
        documentNeedsUpdate,
        publishedDocumentVersion,
        storedCommentData,
        setStoredCommentData,
        addSubscriber,
        setContentType,
        setContentId,
        addCommentInCache,
        deleteCommentInCache,
        unsubscribeFromPubSub
    ]);
    const handleFetchContentVersionEvent = (0, $42omo.useCallback)(()=>{
        setDocumentNeedsUpdate(true);
    }, [
        setDocumentNeedsUpdate
    ]);
    const handleEventFetchSuccess = (0, $42omo.useCallback)((res)=>{
        // TODO: Parse the events returned for 'resolved', 'unresolved', and 'delete' when they are added
        //       for now we just reload the content when the user comes back
        // For now all we have is create events, which means we will miss things, but only update if a new ones were created
        if (res.commentEvents.length > 0) {
            setDocumentUpdated(true);
            setRefetchContent(true);
        }
    }, [
        setRefetchContent,
        setDocumentUpdated
    ]);
    if (!userId) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).INLINE,
        subscribeToPubSubEvents: subscribeToPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onFetchContentVersionEvent: handleFetchContentVersionEvent,
        inactiveInterval: 0,
        returnInterval: 0
    });
};
const $24269a0cd7d91594$var$WithAnnotationsWrapperComponent = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { flags: flags, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, updateDocument: updateDocument, isNestedRender: t1, children: children, lastModifiedDate: lastModifiedDate, isArchived: t2 } = t0;
    const isNestedRender = t1 === undefined ? false : t1;
    const isArchived = t2 === undefined ? false : t2;
    const { setDocumentUpdated: setDocumentUpdated, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { refetchContent: refetchContent } = (0, $5pQ1Y.useContentRefetch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentType: contentType } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { selectionProps: selectionProps, viewProps: viewProps, hoverProps: hoverProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { isHighlightOptionPanelEnabled: isHighlightOptionPanelEnabled } = (0, $3D6uL.useIsHighlightOptionPanelEnabled)();
    const handleAnnotationsLoaded = $24269a0cd7d91594$var$_temp;
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== flags || $[4] !== setDocumentNeedsUpdate || $[5] !== setDocumentUpdated || $[6] !== setPublishedDocumentVersion || $[7] !== setRefetchContent) {
        t4 = (versionNumber)=>{
            setRefetchContent(false);
            setDocumentUpdated(true);
            setDocumentNeedsUpdate(false);
            flags.hideAllFlags();
            if (versionNumber) setPublishedDocumentVersion(versionNumber);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "refetched",
                    actionSubject: "content",
                    objectId: contentId,
                    contentType: contentType,
                    source: "viewPageScreen"
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = flags;
        $[4] = setDocumentNeedsUpdate;
        $[5] = setDocumentUpdated;
        $[6] = setPublishedDocumentVersion;
        $[7] = setRefetchContent;
        $[8] = t4;
    } else t4 = $[8];
    const handleOnRefetchComplete = t4;
    let t5;
    if ($[9] !== adfDocument || $[10] !== annotationProvider || $[11] !== children || $[12] !== contentId || $[13] !== contentType || $[14] !== handleOnRefetchComplete || $[15] !== hoverProps || $[16] !== isArchived || $[17] !== isHighlightOptionPanelEnabled || $[18] !== isNestedRender || $[19] !== isOffline || $[20] !== lastModifiedDate || $[21] !== refetchContent || $[22] !== rendererRef || $[23] !== selectionProps || $[24] !== updateDocument || $[25] !== viewProps) {
        t5 = annotationProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1befae30f885f9b9$export$f9718e664221d42a), {
            render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
                    key: contentId,
                    metric: (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7o2V.AnnotationsWrapper), {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    annotationProvider: annotationProvider,
                    isNestedRender: isNestedRender,
                    onLoadComplete: handleAnnotationsLoaded
                }, !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0779e224f4e996ea$export$6f846e47e87c2a09), null), selectionProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$SelectionComponentLoader, {
                    ...selectionProps,
                    isOffline: isOffline,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    adfDocument: adfDocument,
                    getSelectionContext: ()=>actions.getSelectionContext(),
                    isHighlightOptionPanelEnabled: (0, $6mKj3.expValEquals)("confluence_frontend_allow_comments_if_toolbar_off", "isEnabled", true) ? isHighlightOptionPanelEnabled : true
                }), hoverProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$HoverComponentLoader, {
                    ...hoverProps,
                    isOffline: isOffline
                }), viewProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$ViewComponentLoader, {
                    ...viewProps,
                    isOffline: isOffline
                }), children), !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61084f20d36cc3f6$export$34418bee20f397f), {
                    isArchived: isArchived,
                    rendererRef: rendererRef
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                    actions: actions,
                    pageId: contentId
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$InlineCommentsPubSubHandler, {
                    contentId: contentId,
                    contentType: contentType,
                    updateDocument: updateDocument,
                    rendererActions: actions
                }), contentId && (0, $6mKj3.expValEquals)("confluence_inline_reactions", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fFRTr.InlineReactionsPubSubHandler), {
                    contentId: contentId,
                    contentType: contentType === "blogpost" ? "blogpost" : "page",
                    rendererActions: actions,
                    updateDocument: updateDocument
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), {
                    contentId: contentId,
                    shouldRefetch: refetchContent,
                    refetchImmediately: true,
                    onRefetchComplete: handleOnRefetchComplete
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$InlineCommentLinkHandlerLoader, null))
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
        $[9] = adfDocument;
        $[10] = annotationProvider;
        $[11] = children;
        $[12] = contentId;
        $[13] = contentType;
        $[14] = handleOnRefetchComplete;
        $[15] = hoverProps;
        $[16] = isArchived;
        $[17] = isHighlightOptionPanelEnabled;
        $[18] = isNestedRender;
        $[19] = isOffline;
        $[20] = lastModifiedDate;
        $[21] = refetchContent;
        $[22] = rendererRef;
        $[23] = selectionProps;
        $[24] = updateDocument;
        $[25] = viewProps;
        $[26] = t5;
    } else t5 = $[26];
    return t5;
};
const $24269a0cd7d91594$export$548dda15276d1592 = (0, $7aRa9.withFlags)($24269a0cd7d91594$var$WithAnnotationsWrapperComponent);
function $24269a0cd7d91594$var$_temp(t0) {
    const { numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments } = t0;
    const options = {
        customData: {
            isFabricPage: true,
            numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments
        }
    };
    (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC).stop(options);
}
module.exports["WithAnnotationsWrapper"] = $24269a0cd7d91594$export$548dda15276d1592;

});

parcelRegister("5XUQk", function(module, exports) {

let $457e8e42bd8122c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $457e8e42bd8122c1$var$load("gHdpU"),
    $457e8e42bd8122c1$var$load("8HygH"),
    $457e8e42bd8122c1$var$load("G9L45"),
    $457e8e42bd8122c1$var$load("2YffH"),
    $457e8e42bd8122c1$var$load("6wr18"),
    $457e8e42bd8122c1$var$load("5UCxV"),
    $457e8e42bd8122c1$var$load("dwSiO"),
    $457e8e42bd8122c1$var$load("hL8y0"),
    $457e8e42bd8122c1$var$load("1Ng8f"),
    $457e8e42bd8122c1$var$load("evP3v"),
    $457e8e42bd8122c1$var$load("bpPDZ"),
    $457e8e42bd8122c1$var$load("5Oaw3"),
    $457e8e42bd8122c1$var$load("1jVx9"),
    $457e8e42bd8122c1$var$load("1GCFv"),
    $457e8e42bd8122c1$var$load("36WYv"),
    $457e8e42bd8122c1$var$load("5g7dr"),
    $457e8e42bd8122c1$var$load("5wr4F"),
    $457e8e42bd8122c1$var$load("fcJIN"),
    $457e8e42bd8122c1$var$load("cmqxT"),
    $457e8e42bd8122c1$var$load("ifvan"),
    $457e8e42bd8122c1$var$load("82Jpo"),
    $457e8e42bd8122c1$var$load("bDpLy"),
    $457e8e42bd8122c1$var$load("cV1Ln"),
    $457e8e42bd8122c1$var$load("5I8ad"),
    $457e8e42bd8122c1$var$load("d2YjW"),
    $457e8e42bd8122c1$var$load("im1VN"),
    $457e8e42bd8122c1$var$load("eFu2n"),
    $457e8e42bd8122c1$var$load("czOM6"),
    $457e8e42bd8122c1$var$load("jWHz7"),
    $457e8e42bd8122c1$var$load("7o9KM"),
    $457e8e42bd8122c1$var$load("fb7LO"),
    $457e8e42bd8122c1$var$load("j8WjL"),
    $457e8e42bd8122c1$var$load("1AfmQ"),
    $457e8e42bd8122c1$var$load("3b4Vy"),
    $457e8e42bd8122c1$var$load("f1rEg"),
    $457e8e42bd8122c1$var$load("k7tiZ"),
    $457e8e42bd8122c1$var$load("9XYQ9"),
    $457e8e42bd8122c1$var$load("9anPW"),
    $457e8e42bd8122c1$var$load("1qlDN"),
    $457e8e42bd8122c1$var$load("1yVM6"),
    $457e8e42bd8122c1$var$load("jyDas"),
    $457e8e42bd8122c1$var$load("7EorR"),
    $457e8e42bd8122c1$var$load("e4wOQ"),
    $457e8e42bd8122c1$var$load("5pvpJ"),
    $457e8e42bd8122c1$var$load("6iz6l"),
    $457e8e42bd8122c1$var$load("4SCW2"),
    $457e8e42bd8122c1$var$load("9q75n"),
    $457e8e42bd8122c1$var$load("iYHbd"),
    $457e8e42bd8122c1$var$load("3q2Ng"),
    $457e8e42bd8122c1$var$load("jRpDi"),
    $457e8e42bd8122c1$var$load("Wowvf"),
    $457e8e42bd8122c1$var$load("41PFq"),
    $457e8e42bd8122c1$var$load("jE9nA"),
    $457e8e42bd8122c1$var$load("guyM5"),
    $457e8e42bd8122c1$var$load("hhss7"),
    $457e8e42bd8122c1$var$load("ffEVr"),
    $457e8e42bd8122c1$var$load("1oHTu"),
    $457e8e42bd8122c1$var$load("juJ52"),
    $457e8e42bd8122c1$var$load("gl4lh")
]).then(()=>parcelRequire('11FDr'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("aWPJG", function(module, exports) {

let $7f8773d66dcbf39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f8773d66dcbf39f$var$load("41PFq"),
    $7f8773d66dcbf39f$var$load("jE9nA"),
    $7f8773d66dcbf39f$var$load("1oHTu"),
    $7f8773d66dcbf39f$var$load("juJ52"),
    $7f8773d66dcbf39f$var$load("8HygH"),
    $7f8773d66dcbf39f$var$load("G9L45"),
    $7f8773d66dcbf39f$var$load("hL8y0"),
    $7f8773d66dcbf39f$var$load("1Ng8f"),
    $7f8773d66dcbf39f$var$load("jdmfD"),
    $7f8773d66dcbf39f$var$load("1jVx9"),
    $7f8773d66dcbf39f$var$load("cJsay"),
    $7f8773d66dcbf39f$var$load("1GCFv"),
    $7f8773d66dcbf39f$var$load("36WYv"),
    $7f8773d66dcbf39f$var$load("dZsGY"),
    $7f8773d66dcbf39f$var$load("7uRYm"),
    $7f8773d66dcbf39f$var$load("18ilu")
]).then(()=>parcelRequire('3Xs7k'));

});

parcelRegister("9rqD4", function(module, exports) {

let $6dfb4aa7b6a3f076$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6dfb4aa7b6a3f076$var$load("41PFq"),
    $6dfb4aa7b6a3f076$var$load("jE9nA"),
    $6dfb4aa7b6a3f076$var$load("1oHTu"),
    $6dfb4aa7b6a3f076$var$load("juJ52"),
    $6dfb4aa7b6a3f076$var$load("8HygH"),
    $6dfb4aa7b6a3f076$var$load("G9L45"),
    $6dfb4aa7b6a3f076$var$load("dgH7p"),
    $6dfb4aa7b6a3f076$var$load("4zf7L"),
    $6dfb4aa7b6a3f076$var$load("2HvvO"),
    $6dfb4aa7b6a3f076$var$load("5J8Xh"),
    $6dfb4aa7b6a3f076$var$load("6wr18"),
    $6dfb4aa7b6a3f076$var$load("hL8y0"),
    $6dfb4aa7b6a3f076$var$load("1jVx9"),
    $6dfb4aa7b6a3f076$var$load("eik0U"),
    $6dfb4aa7b6a3f076$var$load("cJsay"),
    $6dfb4aa7b6a3f076$var$load("jEvga"),
    $6dfb4aa7b6a3f076$var$load("1GCFv"),
    $6dfb4aa7b6a3f076$var$load("36WYv"),
    $6dfb4aa7b6a3f076$var$load("dZsGY"),
    $6dfb4aa7b6a3f076$var$load("fDWK8"),
    $6dfb4aa7b6a3f076$var$load("7uRYm"),
    $6dfb4aa7b6a3f076$var$load("dzUzj"),
    $6dfb4aa7b6a3f076$var$load("dpC8y"),
    $6dfb4aa7b6a3f076$var$load("lCT7Q"),
    $6dfb4aa7b6a3f076$var$load("3EXzu"),
    $6dfb4aa7b6a3f076$var$load("kPE95"),
    $6dfb4aa7b6a3f076$var$load("7EorR"),
    $6dfb4aa7b6a3f076$var$load("ffEVr"),
    $6dfb4aa7b6a3f076$var$load("70IPm"),
    $6dfb4aa7b6a3f076$var$load("jeh7F"),
    $6dfb4aa7b6a3f076$var$load("lpzz1")
]).then(()=>parcelRequire('fZ65r'));

});

parcelRegister("43Gw3", function(module, exports) {

let $2f486c0dfcadc161$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f486c0dfcadc161$var$load("l1bfS").then(()=>parcelRequire('4K1uG'));

});


//# sourceMappingURL=PageContentRendererFabric.08bed3b1.js.map
